module.exports = __webpack_public_path__ + "static/img/advertisement-3.7ed4725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement-3.jpg
// module id = cQc9
// module chunks = 1